import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { mobileCheck, iOS } from "./helpers/mobile-check";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

window.addEventListener('load', () => {
    // Disable ScrollSmoother on touch/mobile devices to prevent iOS Safari issues
    // This prevents background image z-index bugs and scrolling conflicts
    if (mobileCheck() || iOS() || ScrollTrigger.isTouch) {
        console.log('ScrollSmoother disabled on touch/mobile device');
        return;
    }

    const smoother = ScrollSmoother.create({
        smooth: 2, // how long (in seconds) it takes to "catch up" to the native scroll position
        effects: true, // looks for data-speed and data-lag attributes on elements
        smoothTouch: false, // Explicitly disable on touch devices
        wholePixels: true, // Force whole pixel values to prevent sub-pixel rendering gaps
    });

    window.smoother = smoother;
});
